import { Injectable } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { DialogService } from "@teammood/shared/ui/dialog";
import { TaskbookService } from "../taskbook-triage/taskbook.service";
import { KudosTaskDetailsDialogComponent } from "./task-details/kudos-task-details-dialog/kudos-task-details-dialog.component";
import { PollTaskDetailsDialogComponent } from "./task-details/poll-task-details-dialog/poll-task-details-dialog.component";
import { ITeam } from "../team/team.type";
import { EmptyTaskbookRedirectionDialogComponent } from "../taskbook-triage/empty-taskbook-redirection-dialog/empty-taskbook-redirection-dialog.component";

@Injectable({
    providedIn: 'root'
})
export class TaskBookBacklogDialogService {
    constructor(
        private dialogService: DialogService,
        private taskbookService: TaskbookService
    ) { }

    async kudosTaskDetails(kudosId): Promise<MatDialogRef<KudosTaskDetailsDialogComponent>> {
        return this.dialogService.open(KudosTaskDetailsDialogComponent, {
            width: '100%',
            maxWidth: '1200px',
            enterAnimationDuration: 300,
            exitAnimationDuration: 300,
            data: {
                kudosId: kudosId
            }
        });
    }

    pollTaskDetails(pollId: string, teams: ITeam[], context: string, mode: string, resultOccurrenceId: string = null): Promise<MatDialogRef<PollTaskDetailsDialogComponent>> {
        return this.dialogService.open(PollTaskDetailsDialogComponent, {
            width: '100%',
            maxWidth: '1200px',
            enterAnimationDuration: 300,
            exitAnimationDuration: 300,
            data: {
                pollId: pollId, 
                teams: teams,
                context: context,
                mode: mode,
                resultOccurrenceId: resultOccurrenceId
            }
        });
    }

    async openEmptyTaskbookBacklogDialog(filter, hasMoreItemsInOtherTeams): Promise<MatDialogRef<EmptyTaskbookRedirectionDialogComponent>> {
        return this.dialogService.open(EmptyTaskbookRedirectionDialogComponent, {
            width: '100%',
            maxWidth: '600px',
            enterAnimationDuration: 300,
            exitAnimationDuration: 300,
            data: {
                filter: filter,
                hasMoreItemsInOtherTeams: hasMoreItemsInOtherTeams
            }
        });
    }
}